import { Store } from "pullstate";

export type ContextStore = {
  organizationId?: string;
  organizationName?: string;
  organizationIdDisabled: boolean;
  clientId?: string;
  organizationTypeId?: string;
};

const contextStore = new Store<ContextStore>({
  organizationIdDisabled: false,
});

export default contextStore;
